export type Size2D = {
    width: number;
    height: number;
};
